import Header from "../../Header/Header";

import React, {
  useState,
  useEffect
} from "react";

import "./StaffProfile.css";

const StaffProfile = () => {

  // URL PARAMS

  const params =
  new URLSearchParams(
    window.location.search
  );

  const employeeId =
  params.get("employeeId");

  // STATES

  const [employee, setEmployee]
  = useState(null);

  const [showAttendance,
  setShowAttendance]
  = useState(false);

  const [showSalary,
  setShowSalary]
  = useState(false);

  const [showLeavePopup,
  setShowLeavePopup]
  = useState(false);

  const [leaveText,
  setLeaveText]
  = useState("");

  // FETCH EMPLOYEE DATA

  useEffect(() => {

    // NO LOGIN

    if (!employeeId) {

      window.location.href = "/";

      return;
    }

    const fetchEmployeeData =
    async () => {

      try {

        const response =
        await fetch(
          "https://fidinventures.in/api/getEmployee.php",
          {
            method: "POST",

            headers: {
              "Content-Type":
              "application/json",
            },

            body: JSON.stringify({

              employeeId:
              employeeId,

            }),
          }
        );

        const data =
        await response.json();

        console.log(data);

        if (data.success) {

          const updatedEmployee = {

            employeeId:
            employeeId,

            name:
            data.employee_name,

            salary:
            data.salary_status,

            presentDays:
            data.present_days,

            absentDays:
            data.absent_days,

            leaveApplication:
            data.leave_application,

            leaveStatus:
            data.leave_status

          };

          setEmployee(
            updatedEmployee
          );

        } else {

          window.location.href =
          "/";
        }

      } catch (error) {

        console.log(error);
      }
    };

    fetchEmployeeData();

  }, [employeeId]);

  // NO LOGIN

  if (!employee) {

    return null;
  }

  // DESTRUCTURE

  const {

    name,

    salary,

    presentDays,

    absentDays,

    leaveApplication,

    leaveStatus

  } = employee;

  // SALARY HISTORY

  const salaryHistory = [

    {
      status: salary,

      date:
      "Updated by Admin",
    },

  ];

  // LEAVE SUBMIT

  const handleLeaveSubmit =
  async () => {

    if (!leaveText) {

      alert(
        "Please write leave"
      );

      return;
    }

    try {

      const response =
      await fetch(
        "https://fidinventures.in/api/applyLeave.php",
        {
          method: "POST",

          headers: {
            "Content-Type":
            "application/json",
          },

          body: JSON.stringify({

            employeeId,

            leaveApplication:
            leaveText

          }),
        }
      );

      const data =
      await response.json();

      if (data.success) {

        alert(
          "Leave Applied"
        );

        window.location.reload();

      } else {

        alert("Failed");
      }

    } catch (error) {

      console.log(error);
    }
  };

  // LOGOUT

  const handleLogout = () => {

    window.location.href =
    "/";

  };

  return (

    <>

      <Header />

      <div className="staff-profile">

        {/* BACKGROUND */}

        <div className="bg-circle circle1"></div>

        <div className="bg-circle circle2"></div>

        {/* MAIN */}

        <div className="profile-container">

          {/* HEADER */}

          <div className="profile-header">

            <div>

              <h1>

                Welcome,

                <span>
                  {" "}
                  {name}
                </span>

              </h1>

              <p>
                Employee Dashboard
              </p>

            </div>

            <button
              className="logout-btn"
              onClick={handleLogout}
            >
              Logout
            </button>

          </div>

          {/* GRID */}

          <div className="profile-grid">

            {/* NAME */}

            <div className="profile-card">

              <h2>
                Employee Name
              </h2>

              <p>
                {name}
              </p>

            </div>

            {/* ATTENDANCE */}

            <div className="profile-card">

              <h2>
                Attendance
              </h2>

              <p className="present">

                Present Days:
                {" "}
                {presentDays}

              </p>

              <p className="absent">

                Absent Days:
                {" "}
                {absentDays}

              </p>

              <button
                className="history-btn"
                onClick={() =>
                  setShowAttendance(true)
                }
              >
                View Attendance
              </button>

            </div>

            {/* SALARY */}

            <div className="profile-card">

              <h2>
                Salary Status
              </h2>

              <p className="paid">
                {salary}
              </p>

              <span>
                Salary Status Updated
              </span>

              <button
                className="history-btn"
                onClick={() =>
                  setShowSalary(true)
                }
              >
                View Salary
              </button>

            </div>

            {/* LEAVE */}

            <div className="profile-card leave-card">

              <h2>
                Leave Application
              </h2>

              <textarea

                placeholder=
                "Write your leave application..."

                value={leaveText}

                onChange={(e) =>
                  setLeaveText(
                    e.target.value
                  )
                }

              ></textarea>

              <button
                onClick={
                  handleLeaveSubmit
                }
              >
                Submit Leave
              </button>

              <button
                className="history-btn"
                onClick={() =>
                  setShowLeavePopup(true)
                }
              >
                View Leave Status
              </button>

            </div>

            {/* RULES */}

            <div className="profile-card rules-card">

              <h2>
                Company Rules
              </h2>

              <ul>

                <li>
                  Maintain office discipline.
                </li>

                <li>
                  Attendance is mandatory.
                </li>

                <li>
                  Respect all employees.
                </li>

                <li>
                  Complete tasks before deadlines.
                </li>

                <li>
                  Maintain confidentiality.
                </li>

              </ul>

            </div>

          </div>

        </div>

        {/* ATTENDANCE POPUP */}

        {showAttendance && (

          <div className="popup-overlay">

            <div className="popup-box">

              <h2>
                Attendance Details
              </h2>

              <div className="history-item">

                <p>

                  Present Days:
                  {" "}
                  {presentDays}

                </p>

                <p>

                  Absent Days:
                  {" "}
                  {absentDays}

                </p>

              </div>

              <button
                className="close-popup"
                onClick={() =>
                  setShowAttendance(false)
                }
              >
                Close
              </button>

            </div>

          </div>

        )}

        {/* SALARY POPUP */}

        {showSalary && (

          <div className="popup-overlay">

            <div className="popup-box">

              <h2>
                Salary History
              </h2>

              {salaryHistory.map(
                (item, index) => (

                  <div
                    className="history-item"
                    key={index}
                  >

                    <p>
                      {item.status}
                    </p>

                    <span>
                      {item.date}
                    </span>

                  </div>
                )
              )}

              <button
                className="close-popup"
                onClick={() =>
                  setShowSalary(false)
                }
              >
                Close
              </button>

            </div>

          </div>

        )}

        {/* LEAVE POPUP */}

        {showLeavePopup && (

          <div className="popup-overlay">

            <div className="popup-box">

              <h2>
                Leave Status
              </h2>

              <div className="history-item">

                <p>

                  {leaveStatus
                    ? leaveStatus
                    : "Pending"}

                </p>

                <span>

                  {leaveApplication
                    ? leaveApplication
                    : "No Leave Applied"}

                </span>

              </div>

              <button
                className="close-popup"
                onClick={() =>
                  setShowLeavePopup(false)
                }
              >
                Close
              </button>

            </div>

          </div>

        )}

      </div>

    </>

  );
};

export default StaffProfile;